import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'
import { pick } from 'ramda'

import { generalClient } from '../../../../utils/apollo/api'
import { ACTIVITY_TAG_TYPE } from '../../_constants'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertTag($input: TagInput) {
    upsertTag(input: $input) {
      id
      name
      color
      type
    }
  }
`

const cleanRequest = form => ({ ...pick(['id', 'name', 'color'], form), type: ACTIVITY_TAG_TYPE })

const validate = (form, setErrors) => {
  const errors = [...appendIf(!form.name, { path: ['name'], message: 'Campo obrigatório' })]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveTag = () => {
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Tags'], client: generalClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
